import { useState, useEffect, useRef } from 'react'

export function useFakeLoading() {
  
  const [isLoading, setIsLoading] = useState(true)
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!isLoading) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    } else if (intervalRef.current == null){
      intervalRef.current = setInterval(() => setIsLoading(false), 3000)
    } else { return }
  }, [isLoading, intervalRef])

  return isLoading
}